module.exports = __webpack_public_path__ + "static/media/Desktop_Purpose_23.04fb111b.png";